<template>
  <step :number="2" :active="active">
    <template v-slot:head>
      {{ i18n.step_2 }}
    </template>

    <template v-slot:content>
      <div
        v-if="active && activeBoxSpecification"
        class="pt-3 px-3 pt-md-4 px-md-4"
      >
        <div class="row">
          <div
            class="col-md-4 col-lg-3 mb-3 mb-md-4"
            v-for="(dimension, key) in dimensions"
            :key="key"
          >
            <dimension-input
              :id="key"
              :min="dimension.min"
              :max="dimension.max"
              :label="dimension.label"
              :unit="dimension.unit"
              :placeholder="dimension.placeholder"
              :value="formInput[key]"
              @change="(event) => storeFormInput(key, event.currentTarget.value)"
              @keyup="(event) => storeFormInput(key, event.currentTarget.value)"
            />
          </div>

          <div class="col-md-4 col-lg-3 mb-3 mb-md-4" v-if="amount">
            <dimension-input
              id="amount"
              :min="amount.min"
              :max="amount.max"
              :label="amount.label"
              :placeholder="amount.placeholder"
              :value="formInput.amount"
              @change="(event) => storeFormInput('amount', event.currentTarget.value)"
              @keyup="(event) => storeFormInput('amount', event.currentTarget.value)"
            />
          </div>
        </div>
      </div>
    </template>
  </step>
</template>

<script>
import { mapGetters } from 'vuex';
import Step from './Step';
import DimensionInput from './fields/DimensionInput';
import removeEmptyFromObject from '../../helpers/removeEmptyFromObject';

export default {
  components: {
    DimensionInput,
    Step,
  },

  props: {
    active: Boolean,
  },

  computed: {
    ...mapGetters([
      'activeBoxSpecification',
      'formInput',
    ]),

    dimensions() {
      if (!this.activeBoxSpecification) {
        return [];
      }

      return removeEmptyFromObject(this.activeBoxSpecification.dimensions);
    },

    amount() {
      if (!this.activeBoxSpecification) {
        return [];
      }

      return removeEmptyFromObject(this.activeBoxSpecification.amount);
    },
  },

  methods: {
    storeFormInput(key, value) {
      this.$store.commit('setFormInput', [key, value]);
    },
  },
};
</script>
